import ABI from '../NFTStaker/NFTStaker.json'

export const CONTARCT_ADDRESS ="0xc66eEBcC0B8C38C85E0B700a3B8c03B1FeF00689";


const NFTStaker =  (web3) =>  new web3.eth.Contract(ABI.abi, CONTARCT_ADDRESS);

export default NFTStaker;


// IMPORTANT NOTE THIS IS WEB3 JS, I HAVE ANOTHER FILE USING ETHER JS WHICH I IMPLENTED FOR THE FUNCTIONS HOOKS